import NetworkLogic from "../../Shared/NetworkLogic";
import Player from "../../Models/Player";
import AudioManager from "../../Shared/AudioManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class ShareDetails extends cc.Component {
    @property(cc.Node)
    nodata : cc.Node = null;
    @property(cc.SpriteFrame)
    sp1: cc.SpriteFrame = null;
    @property(cc.SpriteFrame)
    sp2: cc.SpriteFrame = null;
    @property(cc.Node)
    content: cc.Node = null;

    private data = null;

    onLoad () {}

    onEnable(): void {
        let data = {
            "day":365
        };
        NetworkLogic.agentShareDetail(data,1,9999,function (rdata) {
            console.log("==== 分享记录data：",rdata);
            this.data = rdata;
            if (!rdata  || rdata.length <= 0) return;
            this.nodata.active = false;
            let item = null;
            if (this.content.children.length > rdata.length){
                for (let i = rdata.length; i < this.content.children.length;i++){
                    this.content.children[i].active = false;
                }
            }
            for (let i = 0; i < rdata.length;i++){
                if(this.content.children.length > i){
                    item = this.content.children[i];
                }
                else
                    item = cc.instantiate(this.content.children[0]);
                item.getChildByName("labName").getComponent(cc.Label).string = rdata[i].date;
                item.getChildByName("labMoney").getComponent(cc.Label).string = Player.getPy("currencySymbol") + rdata[i].money;
                item.getChildByName("sprite").getComponent(cc.Sprite).spriteFrame = (i % 2 === 0 ? this.sp1 : this.sp2);
                item.parent = this.content;
                item.setSiblingIndex(0);
                item.active = true;
            }
        }.bind(this),function () {
            console.log("==== 分享记录错误");
        }.bind(this))
    }

    start () {

    }
    onBtnClick(){
        AudioManager.playSound("close");
        this.node.active  =  false;
    }


}
